import containerItem from "../type/item/container.js";
import printContainer from "../type/item/printContainer.js";
import vueStore from "../config.js";
import * as namespaceStore from "../namespaceStore.js"
import basePage from "./basePage.js";
const print_page = class extends basePage {
    Background = [];//list class containerItem
    PrinterStatus = [];//list class containerItem
    HomeButton = [];//list class containerItem
    Foreground = [];//list class containerItem
    PrintButton = [];//list class containerItem
    Image = [];//list class containerItem
    Name = "Impression";
    constructor(args = {}) {
        super(args);
        this.Background = args.background ? args.background : [];
        this.PrinterStatus = args.printerStatus ? args.printerStatus : [];
        this.HomeButton = args.homeButton ? args.homeButton : [];
        this.Foreground = args.foreground ? args.foreground : [];
        this.PrintButton = args.printButton ? args.printButton : [];
        this.Image = args.image ? args.image : [];
    }
    checkPrintButton() {
        if (this.PrintButton.length == 0) {
            return false;
        }
        else {
            return this.PrintButton.some(el => {
                if (el.PrintPaper == null || el.PrintFormat == null) {
                    return true;
                }
                return false;
            });
        }
    }
    checkIsComplete(result = {isComplete: true, requiredBeforeSave: false, missingElements: []}) {
        result = super.checkIsComplete(result);
        if (this.PrintButton.length == 0) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push(`Page: ${this.Name} - Bouton impression`);
        }
        else if (this.checkPrintButton()) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push(`Page: ${this.Name} - Bouton impression (type de papier ou format d'impression manquant)`);
        }
        return result;
    }
    static variableOfInstance() {
        return [
            { property: "Background", construct: containerItem, jsType: "Array" },
            { property: "HomeButton", construct: containerItem, jsType: "Array" },
            { property: "Foreground", construct: containerItem, jsType: "Array" },
            { property: "PrintButton", construct: printContainer, jsType: "Array", specialFunctionExport: "printButtonExport" },
            { property: "Image", construct: containerItem, jsType: "Array" },
            ...super.variableOfInstance(),
            { property: "PrinterStatus", construct: containerItem, jsType: "Array" },
        ];
    }
    printButtonExport(variableArray = [], ressourceArray = []) {
        const composition = vueStore.getters[namespaceStore.THEME + "/compositions"];
        const listPaperType = [];
        let dataReturn = [];
        composition.forEach(el => {
            if (!listPaperType.includes(el.PrintPapersName)) {
                listPaperType.push(el.PrintPapersName);
            }
        });
        this.PrintButton.forEach(el => {
            let data = el.toExportObject(variableArray, ressourceArray);
            listPaperType.forEach(paper => {
                data.option.printPaper = paper + data.option.printPaper;
                dataReturn.push(data);
            });
        });
        return dataReturn;
    }
    getPropertiesDescription() {
        return [
            ...super.getPropertiesDescription(),
            { iconSVG: "backgroundIcon", name: "Background", text: "Fond", description: "Éléments de fond de la page", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { iconSVG: "backIcon", name: "HomeButton", text: "Bouton retour", description: "Bouton pour revenir à la page d'acceuil", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { iconSVG: "validateIcon", name: "PrintButton", text: "Bouton impression", description: "Bouton pour lancer l'impression", objectType: "PrintContainerItem", jsType: "Array", constructor: printContainer },
            {
                maxElement: 1, name: "PrinterStatus", text: "Etat de l'impression", description: "Etat de l'impression", objectType: "ContainerItem", jsType: "Array", constructor: containerItem, 
                constructorParameter:
                {
                    visibilityAtTheSameTime: false,
                    hideElementType: "TextElement",
                    canBeCopied: false,
                    contents: [
                        { id: "WAITING_PRINT", objectType: "TextElement", canBeRemove: false, canBeDuplicate: false, name: "En attente", text: "En attente d'impression", fontSize: 60, foreground: "#FFFFFF" },
                        { id: "PRINTING", objectType: "TextElement", canBeRemove: false, canBeDuplicate: false, name: "En cours", text: "Impression en cours", fontSize: 60, foreground: "#FFFFFF" },
                        { id: "PRINT_ABORDED", objectType: "TextElement", canBeRemove: false, canBeDuplicate: false, name: "Annuler", text: "Impression annulée", fontSize: 60, foreground: "#e5d400" },
                        { id: "PRINT_ERROR", objectType: "TextElement", canBeRemove: false, canBeDuplicate: false, name: "En erreur", text: "Erreur d'impression", fontSize: 60, foreground: "#c73333" },
                        { id: "PRINT_SUCCESS", objectType: "TextElement", canBeRemove: false, canBeDuplicate: false, name: "Fini", text: "Impression terminée", fontSize: 60, foreground: "#24e851" },
                    ]
                },
            },
            { name: "Foreground", text: "Avant plan", description: "Éléments en avant plan de la page", objectType: "ContainerItem", jsType: "Array", constructor: containerItem },
            { 
                maxElement: 1, iconSVG: "imageCarouselIcon", name: "Image", text: "Resulta", description: "Resulta avant impression", objectType: "ContainerItem", jsType: "Array", constructor: containerItem,
                multipleConstructorParameter: [
                    { canBeCopied: false, contents: [{ id: "RESULT_IMAGE", objectType: "DynamicImage", canBeRemove: false, name: "Photo" }] },
                ]
            },
        ]
    }
}
export default print_page;